import React, { useRef, useState } from 'react'
import { useItemImagesStyles } from '../item-images.styles'
import { Button } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { Loader } from '../../../../components/loader'

interface IProps {
  onFilesSelectedHandler: (files: File[]) => void
  uploadingProgress?: number
}

export const UploadArea: React.FC<IProps> = ({
  onFilesSelectedHandler,
  uploadingProgress,
}): React.ReactElement => {
  const classes = useItemImagesStyles()
  const { t } = useTranslation()
  const [dragEffect, setDragEffect] = useState(false)
  const inputRef = useRef<HTMLInputElement>(null)

  const onFileChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (!event.target.files || event.target.files.length === 0) return
    onFilesSelectedHandler(Array.from(event.target.files))
  }

  const onDropHandler = (event: React.DragEvent<HTMLDivElement>) => {
    event.stopPropagation()
    event.preventDefault()

    setDragEffect(false)
    if (!event.dataTransfer.files || event.dataTransfer.files.length === 0)
      return
    onFilesSelectedHandler(Array.from(event.dataTransfer.files))
  }
  const onDragOverHandler = (event: React.DragEvent<HTMLDivElement>) => {
    event.stopPropagation()
    event.preventDefault()

    event.dataTransfer.dropEffect = 'copy'
    setDragEffect(true)
  }
  const onDragExitHandler = () => {
    setDragEffect(false)
  }

  return (
    <div
      className={classes.uploadArea}
      onClick={() => inputRef.current?.click()}
    >
      <div
        className={`${classes.dragArea} ${dragEffect ? 'highlight' : ''}`}
        onDrop={onDropHandler}
        onDragOver={onDragOverHandler}
        onDragLeave={onDragExitHandler}
      >
        <img src="/images/upload-icon.png" alt="upload" height={42} />
        <div className={classes.dragTitle}>{t('donation.dragToUpload')}</div>
      </div>
      <Button
        variant="contained"
        component="span"
        className={classes.uploadButton}
      >
        {t('donation.browseImageButton')}
      </Button>
      <input
        ref={inputRef}
        type="file"
        onChange={onFileChangeHandler}
        hidden
        accept=".jpg, .png"
      />
      {uploadingProgress !== undefined && uploadingProgress >= 0 && (
        <div className={classes.progressOverlay}>
          <Loader size={25} color="primary" />
        </div>
      )}
    </div>
  )
}

export default UploadArea
